import styled from "styled-components";
import * as Define from '../../utils/defines/defines'

export const Input = styled.input<{align?: string, paddingRight?: number}>`
    width: 98%;
    height: 45px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 10px;
    outline: none;
    padding-left: 15px;
    box-sizing: border-box;
    color: #FFF;
    letter-spacing: 1.5px;
    margin-bottom: 15px;
    transition: .25s;
    padding-right: ${props => props.paddingRight}px;

    text-align: ${props => props.align};

    ::placeholder{
        color: rgba(255,255,255,0.35);
    }

    :focus{
        width: 100%;
        border-color: #5292D1;
        box-shadow: 0 0 0 3px rgba(82,146,209,0.15);
        transition: .25s;
    }

    ${Define.media.mobile`
        font-size: 16px; 
    `}

`